/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Primarynavaria2Inputs */

const en_primarynavaria2 = /** @type {(inputs: Primarynavaria2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const pt_primarynavaria2 = /** @type {(inputs: Primarynavaria2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Primarynavaria2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const primarynavaria2 = /** @type {((inputs?: Primarynavaria2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Primarynavaria2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_primarynavaria2(inputs)
	return pt_primarynavaria2(inputs)
});
export { primarynavaria2 as "primaryNavAria" }